/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Web Vitals rating based on Core Web Vitals thresholds
 */
export enum WebVitalsRating {

    Good = 'good',

    NeedsImprovement = 'needs-improvement',

    Poor = 'poor'
}
